module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-448c34.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
 ** module id = 910
 ** module chunks = 2
 **/